import { render } from "./LangsSelect.vue?vue&type=template&id=b6722b78&scoped=true"
import script from "./LangsSelect.vue?vue&type=script&lang=js"
export * from "./LangsSelect.vue?vue&type=script&lang=js"

import "./LangsSelect.vue?vue&type=style&index=0&id=b6722b78&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6722b78"]])

export default __exports__